import { render, staticRenderFns } from "./PersonalTaxReport.vue?vue&type=template&id=147f3234&"
import script from "./PersonalTaxReport.vue?vue&type=script&lang=js&"
export * from "./PersonalTaxReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTaxReport.vue?vue&type=style&index=0&id=147f3234&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports